export var PERKS = "perks";
export var RECOGNITION = "recognition";
export var REWARD = "reward";
export var INSIGHTS = "insights";
export var MEDICAL = "medical";
export var WALLET = "wallet";
export var PLATFORM = "platform";
export var ONBOARDING = "onboarding";
export var TOUR = "tour";
